import React, { FC } from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import logo_negative from "@/svg/logo-negative.svg";
import { ContactLabel, ContactLabelProps } from "./components";
import { Link } from "gatsby";
import { styled } from "@mui/material/styles";

const LinkStyled = styled(Link)(({ theme }) => ({
  fontSize: "1rem",
  color: theme.palette.grey[100],
  fontWeight: 400,
  lineHeight: 1.5,
  p: 0,
  transition: "opacity 0.3s ease",
  textDecoration: "none",
  ":hover": {
    opacity: 0.7
  }
}));

export const Footer: FC<FooterProps> = ({
  contacts,
  footerLinks,
  copyright
}) => (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme => theme.palette.common.black,
        color: theme => theme.palette.common.white,
        pt: 10,
        pb: 2
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={{ xs: 5, md: 10 }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", lg: "repeat(4, 1fr)", gap: 2 },
              alignItems: "end"
            }}
          >
            <Box
              component="img"
              src={logo_negative}
              alt="10speed logo"
              sx={{ width: 1, maxWidth: 135, mb: { xs: 5, lg: 0 } }}
            />
            {contacts?.map((contact, index) => (
              <ContactLabel key={index} {...contact} />
            ))}
          </Box>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            gap={{ xs: 2, md: 0 }}
            alignItems={{ xs: "flex-start", md: "center" }}
          >
            {!!footerLinks && (
              <Stack
                direction={{ xs: "column", md: "row" }}
                gap={2}
                alignItems={{ xs: "flex-start", md: "center" }}
              >
                {footerLinks?.map((link, index) => (
                    <LinkStyled key={index} to={link.to}>
                      {link.label}
                    </LinkStyled>
                  ))}
              </Stack>
            )}
            <Typography sx={{ opacity: 0.7, fontSize: "1rem" }}>
              {copyright}
            </Typography>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );

export interface FooterProps {
  contacts: ContactLabelProps[];
  copyright: string;
  footerLinks?: {
    label: string;
    to: string;
  }[];
}
